namespace RecordShield.Workspace {
    export interface ViewerRow {
        UserId?: number;
        Publisher?: number;
        Username?: string;
        DisplayName?: string;
        Email?: string;
        Source?: string;
        PasswordHash?: string;
        PasswordSalt?: string;
        LastDirectoryUpdate?: string;
        UserImage?: string;
        IsActive?: number;
        IsdCode?: string;
        Mobile?: string;
        ParentId?: number;
        PackageId?: number;
        CustomerKey?: number;
        TenantId?: number;
        DeviceId?: string;
        LastLogin?: string;
        DeviceType?: string;
        PlayerEdition?: Models.Enums.PlayerEdition;
        Password?: string;
        PasswordConfirm?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace ViewerRow {
        export const idProperty = 'UserId';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Username';
        export const localTextPrefix = 'Workspace.Viewer';

        export namespace Fields {
            export declare const UserId: string;
            export declare const Publisher: string;
            export declare const Username: string;
            export declare const DisplayName: string;
            export declare const Email: string;
            export declare const Source: string;
            export declare const PasswordHash: string;
            export declare const PasswordSalt: string;
            export declare const LastDirectoryUpdate: string;
            export declare const UserImage: string;
            export declare const IsActive: string;
            export declare const IsdCode: string;
            export declare const Mobile: string;
            export declare const ParentId: string;
            export declare const PackageId: string;
            export declare const CustomerKey: string;
            export declare const TenantId: string;
            export declare const DeviceId: string;
            export declare const LastLogin: string;
            export declare const DeviceType: string;
            export declare const PlayerEdition: string;
            export declare const Password: string;
            export declare const PasswordConfirm: string;
            export declare const InsertUserId: string;
            export declare const InsertDate: string;
            export declare const UpdateUserId: string;
            export declare const UpdateDate: string;
        }

        ['UserId', 'Publisher', 'Username', 'DisplayName', 'Email', 'Source', 'PasswordHash', 'PasswordSalt', 'LastDirectoryUpdate', 'UserImage', 'IsActive', 'IsdCode', 'Mobile', 'ParentId', 'PackageId', 'CustomerKey', 'TenantId', 'DeviceId', 'LastLogin', 'DeviceType', 'PlayerEdition', 'Password', 'PasswordConfirm', 'InsertUserId', 'InsertDate', 'UpdateUserId', 'UpdateDate'].forEach(x => (<any>Fields)[x] = x);
    }
}
